import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/powered_by_google_on_white.png'


const _withScopeId = n => (_pushScopeId("data-v-9d6cb38c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "autocomplete" }
const _hoisted_2 = { class: "autocomplete__options-wrapper" }
const _hoisted_3 = { class: "autocomplete__options" }
const _hoisted_4 = {
  key: 0,
  class: "autocomplete__option autocomplete__option--disabled"
}
const _hoisted_5 = {
  key: 1,
  class: "autocomplete__option autocomplete__option--disabled"
}
const _hoisted_6 = ["onMousedown"]
const _hoisted_7 = {
  key: 3,
  class: "autocomplete__logo-wrapper"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "autocomplete__logo"
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]

import { computed, PropType, ref } from 'vue'
import { AutoCompleteOption } from '@/models/shared.model'
import BaseInput from '@/components/BaseInput.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseAutocomplete',
  props: {
  modelValue: {
    type: String,
    required: true,
  },
  options: {
    type: Array as PropType<AutoCompleteOption[]>,
    required: true,
    default: () => [],
  },
  name: {
    type: String,
    required: true,
  },
  required: {
    type: Boolean,
    default: false,
  },
  noOptionsLabel: {
    type: String,
    required: false,
    default: '',
  },
  placeholder: {
    type: String,
    required: false,
    default: '',
  },
  iconLeft: {
    type: String,
    default: null,
  },
  iconRight: {
    type: String,
    default: null,
  },
  iconHeight: {
    type: Number,
    default: undefined,
  },
  iconWidth: {
    type: Number,
    default: undefined,
  },
  iconSize: {
    type: Number,
    default: 24,
  },
  isGoogleSearch: {
    type: Boolean,
    default: false,
  },
  errors: {
    type: Array as PropType<string[] | undefined>,
    default: () => [],
  },
  disabled: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  isLoading: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  disableFiltering: {
    type: Boolean,
    default: false,
  },
},
  emits: ['optionClick', 'update:modelValue', 'blur'],
  setup(__props, { emit: emits }) {

const props = __props



const showOptions = ref(false)

const filteredOptions = computed(() => {
  if (props.isGoogleSearch || props.disableFiltering) {
    return props.options
  } else {
    const filtered = []
    for (const option of props.options) {
      if (option.label.toLowerCase().includes(props.modelValue.toLowerCase())) {
        filtered.push(option)
      }
    }
    return filtered
  }
})

function selectOption(option: AutoCompleteOption) {
  showOptions.value = false
  emits('optionClick', option)
}

function pickFirstOption() {
  if (filteredOptions.value[0]) {
    emits('optionClick', filteredOptions.value[0])
    showOptions.value = false
  }
}

function onBlur() {
  showOptions.value = false
  emits('blur')
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseInput, {
      "model-value": __props.modelValue,
      label: __props.placeholder,
      required: __props.required,
      class: "autocomplete__input",
      "icon-left": __props.iconLeft,
      name: __props.name,
      errors: __props.errors,
      type: "text",
      disabled: __props.disabled,
      autocomplete: 'off',
      onFocus: _cache[0] || (_cache[0] = ($event: any) => (showOptions.value = true)),
      onKeyup: _withKeys(_withModifiers(pickFirstOption, ["exact","stop"]), ["enter"]),
      onBlur: onBlur,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = (value) => emits('update:modelValue', value))
    }, null, 8, ["model-value", "label", "required", "icon-left", "name", "errors", "disabled", "onKeyup"]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        (__props.isLoading && __props.modelValue.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('loading')), 1))
          : (!_unref(filteredOptions).length && __props.modelValue.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.noOptionsLabel), 1))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_unref(filteredOptions), (option, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "autocomplete__option",
                  onMousedown: ($event: any) => (selectOption(option))
                }, [
                  _renderSlot(_ctx.$slots, "option-label", { option: option }, () => [
                    _createTextVNode(_toDisplayString(option.label), 1)
                  ])
                ], 40, _hoisted_6))
              }), 128)),
        (__props.isGoogleSearch && _unref(filteredOptions).length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
          : _createCommentVNode("", true)
      ])
    ], 512), [
      [_vShow, showOptions.value]
    ])
  ]))
}
}

})